import gql from 'graphql-tag';

export const userFragment = gql`
  fragment ListUserPageUser on User {
    id
    name
    email
    country
    roles
    avatar(width: 160, height: 160) {
      id
      url
    }
  }
`;

export const getUserQL = gql`
  query GetUser($id: ID!) {
    user(id: $id) {
      id
      ...ListUserPageUser
    }
  }
  ${userFragment}
`;

export const listUserQL = gql`
  query ListUsers($offset: Int!, $limit: Int!) {
    users: listUser(offset: $offset, limit: $limit) {
      id
      ...ListUserPageUser
    }
  }
  ${userFragment}
`;
